module.exports = __webpack_public_path__ + "img/Thumbnail-Sushi.54396099.jpg";